import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { WithAnimationContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/WithAnimationContainer";

import { useKeywordListComposerContext } from "../KeywordListComposerContext";
import { trackPopupClick } from "../tracking";

const { blue } = colorsPalettes;

const Container = styled(WithAnimationContainer)`
    background-color: ${blue[400]};
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    height: 54px;
    box-sizing: border-box;
    align-items: center;
`;

const Text = styled.span`
    ${setFontVariant("body1", "white")}
`;

export const SelectionBanner = () => {
    const { changeQuery, keywords, removeKeywords, deselectAllKeywords } = useKeywordListComposerContext();
    const selectedKeywords = keywords.filter((keyword) => keyword.selected);
    const key =
        selectedKeywords.length === 1
            ? "auto.keyword.list.generator.body.keyword.selection"
            : "auto.keyword.list.generator.body.keywords.selection";

    const handleDeleteClick = () => {
        changeQuery("");
        removeKeywords(selectedKeywords);
        deselectAllKeywords();
        trackPopupClick({ event: "delete", count: selectedKeywords.length });
    };

    const handleSelectionClear = () => {
        changeQuery("");
        deselectAllKeywords();
        trackPopupClick({ event: "uncheck", count: selectedKeywords.length });
    };

    return (
        <Container>
            <FlexRow
                gap="8px"
                alignItems="center"
            >
                <Text>{translate(key, { count: selectedKeywords.length })}</Text>
                <IconButton
                    type="invertedTransparent"
                    iconName="delete"
                    onClick={handleDeleteClick}
                >
                    {translate("common.delete")}
                </IconButton>
            </FlexRow>
            <Button
                type="flatNegative"
                onClick={handleSelectionClear}
            >
                {translate("table.selection.clear.all")}
            </Button>
        </Container>
    );
};
